<template>
  <v-card>
    <v-card-title>
      <v-row class="no-gutters">
        <v-col> Events List </v-col>
        <v-spacer></v-spacer>
        <v-col>
          <v-btn text color="primary" class="float-md-right" @click="newEvent">
            <v-icon class="mr-3">fal fa-plus fa-lg</v-icon>
            Add Event
          </v-btn>
        </v-col>
      </v-row>
    </v-card-title>
    <v-card-text>
      <v-data-table
        :items="events"
        :headers="headers"
        :server-items-length="pagination.total"
        :loading="loading.table"
        @update:page="changePage"
      >
        <template v-slot:item.url="{ item }">
          <a :href="item.url" target="_blank">
            {{ item.url }}
          </a>
        </template>
        <template v-slot:item.total_assignees="{ item }">
          <v-btn
            text
            color="blue"
            :disabled="item.total_assignees === 0"
            @click="showAttendees(item)"
            :loading="loading.attendees_dialog"
          >
            {{ item.total_assignees }}
          </v-btn>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="error"
                class="mr-2"
                icon
                v-bind="attrs"
                v-on="on"
                v-if="isAuthorizeToEdit(item)"
                @click="confirmDelete(item)"
              >
                <i class="fas fa-trash"></i>
              </v-btn>
            </template>
            <span> Delete Event </span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="warning"
                icon
                v-bind="attrs"
                v-on="on"
                v-if="isAuthorizeToEdit(item)"
                @click="editEvent(item)"
              >
                <i class="fas fa-pencil"></i>
              </v-btn>
            </template>
            <span> Edit Event </span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card-text>
    <event-form-dialog :fetch-data="getEvents" />
    <event-attendees-dialog />
    <confirm-dialog
      :confirm-action="deleteEvent"
      :show-dialog="showConfirmDialog"
      :close-dialog="closeConfirmDialog"
      :loading="loading.table"
    >
      Are you sure you want to continue?
    </confirm-dialog>
  </v-card>
</template>

<script>
import EventFormDialog from '@/components/events/EventFormDialog';
import EventAttendeesDialog from '@/components/events/EventAttendeesDialog';
import { some as _some } from 'lodash-es';
import ConfirmDialog from '@/components/dialogs/ConfirmDialog';

export default {
  name: 'ListEvents',
  components: { ConfirmDialog, EventAttendeesDialog, EventFormDialog },
  data() {
    return {
      headers: [
        {
          text: 'Name',
          value: 'name',
        },
        {
          text: 'URL',
          value: 'url',
        },
        {
          text: 'Start Date',
          value: 'start_at_formatted',
        },
        {
          text: 'End Date',
          value: 'end_at_formatted',
        },
        {
          text: 'Created By',
          value: 'created_by',
        },
        {
          text: '# of Assignees',
          value: 'total_assignees',
        },
        {
          text: 'Actions',
          value: 'actions',
        },
      ],
      pagination: {
        current_page: 1,
        last_page: 10,
        items: 10,
        total: 100,
      },
      events: [],
      loading: {
        table: false,
        attendees_dialog: false,
      },
      selectedItem: {},
      showConfirmDialog: false,
    };
  },
  created() {
    this.getEvents();
    this.getUsers();
  },
  computed: {
    superAdminOrAccountManager() {
      return (
        _some(this.roles, { name: 'super-administrator' }) ||
        _some(this.roles, { name: 'account-manager' })
      );
    },
    users() {
      return this.$store.state.lmsClient.listUsers;
    },
    user() {
      return this.$auth.user();
    },

    isAdmin() {
      return _some(this.$auth.user().roles, { name: 'super-administrator' });
    },

    isManager() {
      return _some(this.$auth.user().roles, { name: 'account-manager' });
    },
  },
  methods: {
    getUsers() {
      this.$store.dispatch('lmsClient/fetchUsersByDealer').then(({ data }) => {
        this.$store.dispatch('lmsClient/setUsers', data);
      });
    },
    isAuthorizeToEdit(event) {
      if (event.user_id === this.user.id) {
        return true;
      }
      if (this.isAdmin) {
        return true;
      }

      return _some(this.users, event.user_id) && this.isManager;
    },
    confirmDelete(event) {
      this.selectedItem = event;

      this.showConfirmDialog = true;

      // console.log(this.showConfirmDialog);
    },
    closeConfirmDialog() {
      this.showConfirmDialog = false;
      this.selectedItem = {};
    },
    deleteEvent() {
      this.loading.table = true;
      this.$http
        .delete(`events/${this.selectedItem.id}`)
        .then(({ data }) => {
          this.$notify('success', 'Event removed!');

          this.getEvents();

          this.loading.table = false;

          this.showConfirmDialog = false;
        })
        .catch(() => {
          this.loading.table = false;
        });
    },
    editEvent(event) {
      this.$store.dispatch('events/setSelectedEvent', event);
      this.$store.dispatch('events/setEventFormDialogState', true);
    },
    showAttendees(event) {
      this.loading.attendees_dialog = true;
      this.$http.get(`events/${event.id}/attendees`).then(({ data }) => {
        this.$store.dispatch('events/setAttendeesState', data.attendees);

        this.$nextTick(() => {
          this.loading.attendees_dialog = false;
        });

        this.$store.dispatch('events/setEventAttendeesDialogState', true);
      });
    },
    newEvent() {
      this.$store.dispatch('events/setSelectedEvent', {});
      this.$store.dispatch('events/setEventFormDialogState', true);
    },
    changePage(page) {
      this.pagination.current_page = page;
      this.getEvents();
    },
    getEvents() {
      this.loading.table = true;
      this.$http
        .get('events', {
          params: {
            paginated: true,
            page: this.pagination.current_page,
            per_page: this.pagination.items,
          },
        })
        .then(({ data }) => {
          this.pagination.last_page = data.meta.last_page;
          this.events = data.data;
          this.pagination.total = data.meta.total;

          this.$nextTick(() => {
            this.loading.table = false;
          });
        });
    },
  },
};
</script>

<style scoped></style>
